import * as React from "react";
import { Header, Table, Icon, Label, TableCellProps } from "semantic-ui-react";

import { textWithLimit } from "../../../utils";

interface Props {
  title?: string;
  subtitle?: string;

  tag?: string;
  subcontent?: any;
  maxLength?: number;
}

const TitleSubtitleFC: React.FC<Props & TableCellProps> = ({
  title,
  subtitle,
  subcontent,
  tag,
  maxLength = 65,
  ...props
}) => {
  const effectiveClassName = [props.className, "flexCell", !!props.onClick && "titleClickable"]
    .filter(Boolean)
    .join(" ");
  return (
    <Table.Cell data-elm-id={`titleCellUserInfo`} {...props} className={effectiveClassName}>
      <Header as="h4" image>
        <Header.Content data-elm-id={`titleCellHeader`}>
          {title && textWithLimit(title, maxLength)}
          {subtitle && (
            <Header.Subheader>
              {textWithLimit(subtitle, 60)}{" "}
              {tag && (
                <Label className="leftMargin" as="a" tag>
                  {tag}
                </Label>
              )}{" "}
            </Header.Subheader>
          )}
          {subcontent}
        </Header.Content>
        {props.onClick && <Icon className={"miniPencil"} size={"mini"} name={"pencil"} />}
      </Header>
    </Table.Cell>
  );
};

export const TitleSubtitleCell = TitleSubtitleFC;
